// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-4[data-v-734d5ab1]{gap:16px}.border-bottom[data-v-734d5ab1]{border-bottom:1px solid #e0e0e0;padding-bottom:8px;margin-bottom:8px}.border-left-primary[data-v-734d5ab1]{border-right:4px solid #1976d2!important}", ""]);
// Exports
module.exports = exports;
